// ** Icons Import
import { Mail, Map, MessageSquare, Layers, CheckSquare, Calendar, FileText, Circle, ShoppingCart, User, Shield, Disc, Sliders, Activity, Home, Music, PlusCircle, Star, Video, BookOpen, Monitor, Layout, Settings } from 'react-feather'
import themeConfig from '../../configs/themeConfig'

export default [
  {
    id: '0',
    title: 'Home',
    icon: <Home size={14} />,
    navLink: themeConfig.app.headRoute + '/Home'
  },
  {
    id: '1',
    title: 'My Songs',
    icon: <Activity size={14} />,
    navLink: themeConfig.app.headRoute + '/manage/artistmusic'
  },

  {
    id: '2',
    title: 'Verifications',
    icon: <Shield size={14} />,
    navLink: themeConfig.app.headRoute + '/manage/verifications'
  },
  {
    id: '4',
    title: 'Users',
    icon: <MessageSquare size={14} />,
    navLink: themeConfig.app.headRoute + '/Manage/User/Admin'
  },
  {
    id: '5',
    title: 'Add Song',
    icon: <PlusCircle size={14} />,
    navLink: themeConfig.app.headRoute + '/Manage/addsong'
  },
  {
    id: '20',
    title: 'Add Song Instagram',
    icon: <PlusCircle size={14} />,
    navLink: themeConfig.app.headRoute + '/instagram/addsong'
  },
  {
    id: '23',
    title: 'Add Spam Song',
    icon: <PlusCircle size={14} />,
    navLink: themeConfig.app.headRoute + '/spamsong/add'
  },

  {
    id: '6',
    title: 'Sounds List',
    icon: <Music size={14} />,
    navLink: themeConfig.app.headRoute + '/Manage/soundslist'
  },
  {
    id: '21',
    title: 'Sounds List Instagram',
    icon: <Music size={14} />,
    navLink: themeConfig.app.headRoute + '/soundslistinstagram'
  },
  {
    id: '22',
    title: 'Sounds List Spam',
    icon: <Music size={14} />,
    navLink: themeConfig.app.headRoute + '/soundslistspam'
  },
  {
    id: '27',
    title: 'Sounds List Spam (Admin)',
    icon: <Music size={14} />,
    navLink: themeConfig.app.headRoute + '/soundslistspamadmin'
  },
  {
    id: '7',
    title: 'Profile',
    icon: <User size={14} />,
    navLink: themeConfig.app.headRoute + '/account'
  },
  {
    id: '8',
    title: 'Duet Ad Video',
    icon: <Disc size={14} />,
    navLink: themeConfig.app.headRoute + '/brandform'
  },
  {
    id: '9',
    title: 'Make Ad Video',
    icon: <CheckSquare size={14} />,
    navLink: themeConfig.app.headRoute + '/brandformscript'
  },
  {
    id: '10',
    title: 'Brand Requests',
    icon: <Disc size={14} />,
    navLink: themeConfig.app.headRoute + '/brandrequests'
  },
  {
    id: '11',
    title: 'My Adverts',
    icon: <Activity size={14} />,
    navLink: themeConfig.app.headRoute + '/mybrandrequests'
  },
  {
    id: '12',
    title: 'Transaction',
    icon: <Activity size={14} />,
    navLink: themeConfig.app.headRoute + '/transactions'
  },
  {
    id: '13',
    title: 'Verification (Tiktokers)',
    icon: <Activity size={14} />,
    navLink: themeConfig.app.headRoute + '/Manage/adminverificationsusers'
  },
  {
    id: '14',
    title: 'Add CapCut',
    icon: <PlusCircle size={14} />,
    navLink: themeConfig.app.headRoute + '/Manage/addcatcupsong'
  },
  {
    id: '15',
    title: 'Influencers Sounds',
    icon: <Music size={14} />,
    navLink: themeConfig.app.headRoute + '/Manage/influencersoundslist'
  },
  {
    id: '16',
    title: 'CapCut List',
    icon: <Music size={14} />,
    navLink: themeConfig.app.headRoute + '/Manage/catcupsoundslist'
  },
  {
    id: '17',
    title: 'Sound List',
    icon: <Music size={14} />,
    navLink: themeConfig.app.headRoute + '/admin/soundlist'
  },
  {
    id: '18',
    title: 'Statics',
    icon: <Star size={14} />,
    navLink: themeConfig.app.headRoute + '/admin/stats'
  },
  {
    id: '19',
    title: 'Sounds List Admin',
    icon: <Music size={14} />,
    navLink: themeConfig.app.headRoute + '/Manage/soundslistadmin'
  },
  {
    id: '24',
    title: 'Verification (Spam)',
    icon: <Music size={14} />,
    navLink: themeConfig.app.headRoute + '/Manage/adminverificationsforspam'
  },
  {
    id: '25',
    title: 'Rejected Videos',
    icon: <Music size={14} />,
    navLink: themeConfig.app.headRoute + '/rejected-videos'
  },
  {
    id: '26',
    title: 'Brand Creator',
    icon: <Music size={14} />,
    navLink: themeConfig.app.headRoute + '/brand-creator'
  },
  {
    id: '28',
    title: 'Brand Creator Requests',
    icon: <CheckSquare size={14} />,
    navLink: themeConfig.app.headRoute + '/brand-creator-requests'
  },
  {
    id: '29',
    title: 'Browse Creators',
    icon: <User size={14} />,
    navLink: themeConfig.app.headRoute + '/browse-creators'
  },
  {
    id: '30',
    title: 'UGC Project',
    icon: <PlusCircle size={14} />,
    navLink: themeConfig.app.headRoute + '/brand-ugc-page'
  },
  {
    id: '31',
    title: 'My UGC Projects',
    icon: <Activity size={14} />,
    navLink: themeConfig.app.headRoute + '/my-ugc-projects'
  },
  {
    id: '32',
    title: 'Creator UGC Dashboard',
    icon: <Activity size={14} />,
    navLink: themeConfig.app.headRoute + '/creator-ugc-dashboard'
  },
  {
    id: '33',
    title: '10k+ Sounds',
    icon: <Music size={14} />,
    navLink: themeConfig.app.headRoute + '/Manage/10ksoundslist'
  },
  {
    id: '34',
    title: 'Lyrics Video Service',
    icon: <Video size={14} />,
    navLink: themeConfig.app.headRoute + '/services/lyrics-video'
  },
  {
    id: '35',
    title: 'Content Ideas',
    icon: <BookOpen size={14} />,
    navLink: themeConfig.app.headRoute + '/services/content-ideas'
  },
  {
    id: '36',
    title: 'AI UGC Advert',
    icon: <Monitor size={14} />,
    navLink: themeConfig.app.headRoute + '/services/ugc-advert'
  },
  {
    id: '37',
    title: 'Social Media Design',
    icon: <Layout size={14} />,
    navLink: themeConfig.app.headRoute + '/services/social-media-content'
  },
  {
    id: '38',
    title: 'Manage Examples',
    icon: <Settings size={14} />,
    navLink: themeConfig.app.headRoute + '/admin/service-examples'
  },
  {
    id: '39',
    title: 'Service Orders',
    icon: <ShoppingCart size={14} />,
    navLink: themeConfig.app.headRoute + '/admin/service-orders'
  }
]